"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

var _colorsModule = _interopRequireDefault(require("../../common/styles/colors.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AreaChartComponent = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var data = _ref.data,
      containerWidth = _ref.containerWidth,
      aspect = _ref.aspect,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 500 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 400 : _ref$height,
      hideX = _ref.hideX,
      hideY = _ref.hideY,
      horizontal = _ref.horizontal,
      vertical = _ref.vertical,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 5 : _ref$strokeWidth,
      _ref$strokeDasharray = _ref.strokeDasharray,
      strokeDasharray = _ref$strokeDasharray === void 0 ? "4" : _ref$strokeDasharray,
      gradientColor = _ref.gradientColor,
      color = _ref.color,
      _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === void 0 ? 10 : _ref$marginTop,
      _ref$marginRight = _ref.marginRight,
      marginRight = _ref$marginRight === void 0 ? 30 : _ref$marginRight,
      _ref$marginLeft = _ref.marginLeft,
      marginLeft = _ref$marginLeft === void 0 ? 30 : _ref$marginLeft,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom,
      tooltips = _ref.tooltips,
      axisLineX = _ref.axisLineX,
      tickLineX = _ref.tickLineX,
      axisLineY = _ref.axisLineY,
      tickLineY = _ref.tickLineY,
      dotWidth = _ref.dotWidth,
      _ref$verticalAlign = _ref.verticalAlign,
      verticalAlign = _ref$verticalAlign === void 0 ? "middle" : _ref$verticalAlign,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "vertical" : _ref$layout,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "right" : _ref$align,
      _ref$areaType = _ref.areaType,
      areaType = _ref$areaType === void 0 ? "monotone" : _ref$areaType,
      areaDataKey = _ref.areaDataKey,
      Xaxisfill = _ref.Xaxisfill,
      Yaxisfill = _ref.Yaxisfill,
      toolTipBackgroundColor = _ref.toolTipBackgroundColor,
      _ref$toolTipPadding = _ref.toolTipPadding,
      toolTipPadding = _ref$toolTipPadding === void 0 ? 5 : _ref$toolTipPadding,
      _ref$XaxisDataKeyName = _ref.XaxisDataKeyName,
      XaxisDataKeyName = _ref$XaxisDataKeyName === void 0 ? "name" : _ref$XaxisDataKeyName,
      _ref$Xaxisinterval = _ref.Xaxisinterval,
      Xaxisinterval = _ref$Xaxisinterval === void 0 ? "preserveStart" : _ref$Xaxisinterval,
      _ref$iconType = _ref.iconType,
      iconType = _ref$iconType === void 0 ? "center" : _ref$iconType,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 10 : _ref$iconSize,
      renderLegends = _ref.renderLegends,
      legendWrapperStyle = _ref.legendWrapperStyle,
      domainVal = _ref.domainVal,
      labelColor = _ref.labelColor;
  return (
    /*#__PURE__*/
    // <ResponsiveContainer width={containerWidth || "50%"} aspect={aspect || 3}>
    _react["default"].createElement(_recharts.ResponsiveContainer, {
      width: containerWidth || "50%",
      height: "80%"
    }, /*#__PURE__*/_react["default"].createElement(_recharts.AreaChart, {
      width: width,
      height: height,
      data: data,
      margin: {
        top: marginTop,
        right: marginRight,
        left: marginLeft,
        bottom: marginBottom
      }
    }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "colorPv",
      x1: "0",
      y1: "0",
      x2: "0",
      y2: "1"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "0%",
      stopColor: gradientColor,
      stopOpacity: 0.55
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "100%",
      stopColor: gradientColor,
      stopOpacity: 0
    }))), /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, {
      dataKey: XaxisDataKeyName,
      interval: Xaxisinterval,
      hide: hideX || false,
      axisLine: axisLineX === false ? false : axisLineX,
      tickLine: tickLineX === false ? false : tickLineX,
      dy: 12,
      allowDataOverflow: false,
      tick: {
        fill: labelColor
      }
    }), /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, {
      hide: hideY || false,
      axisLine: axisLineY === false ? false : axisLineY,
      tickLine: tickLineY === false ? false : tickLineY,
      style: {
        fill: Yaxisfill || _colorsModule["default"].colorBlue7
      },
      allowDataOverflow: false,
      type: "number",
      domain: domainVal
    }), /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
      strokeDasharray: strokeDasharray,
      horizontal: horizontal === false ? false : horizontal,
      vertical: vertical === false ? false : vertical
    }), tooltips ? /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
      content: tooltips,
      wrapperStyle: {
        backgroundColor: toolTipBackgroundColor || _colorsModule["default"].colorwhite,
        padding: toolTipPadding
      }
    }) : /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, null), /*#__PURE__*/_react["default"].createElement(_recharts.Legend, {
      iconSize: iconSize,
      iconType: iconType,
      verticalAlign: verticalAlign,
      layout: layout,
      align: align,
      wrapperStyle: legendWrapperStyle,
      content: renderLegends
    }), dotWidth ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, areaDataKey === null || areaDataKey === void 0 ? void 0 : areaDataKey.map(function (areaKey, index) {
      return /*#__PURE__*/_react["default"].createElement(_recharts.Area, {
        type: areaType,
        dataKey: areaKey,
        stroke: color[index],
        fill: "url(#colorPv)",
        strokeWidth: strokeWidth,
        dot: {
          stroke: color[index],
          strokeWidth: dotWidth
        }
      });
    })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, areaDataKey === null || areaDataKey === void 0 ? void 0 : areaDataKey.map(function (areaKey, index) {
      return /*#__PURE__*/_react["default"].createElement(_recharts.Area, {
        type: areaType,
        dataKey: areaKey,
        stroke: color[index],
        fill: "url(#colorPv)",
        strokeWidth: strokeWidth
      });
    }))))
  );
});

var _default = AreaChartComponent;
exports["default"] = _default;